(() => {
  const article = document.querySelector('[data-ly-advertorial]');
  if (!article || article.dataset.trackingReady === 'true') return;
  article.dataset.trackingReady = 'true';

  const publish = (name, payload = {}) => {
    const privacy = window.Shopify?.customerPrivacy;
    const allowed = !privacy?.analyticsProcessingAllowed || privacy.analyticsProcessingAllowed();
    if (!allowed) return;
    const data = { article: article.dataset.articleVariant || 'unknown', ...payload };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...data });
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      Promise.resolve(window.Shopify.analytics.publish(name, data)).catch(() => {});
    }
  };

  const marketingKeys = /^(utm_.+|fbclid|gclid|ttclid|twclid|msclkid)$/i;
  article.querySelectorAll('a[href*="/products/lymphiva-lymphatic-drainage-drops"]').forEach((link) => {
    const target = new URL(link.href, window.location.origin);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (marketingKeys.test(key) && !target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    link.href = target.toString();
  });

  const sticky = article.querySelector('.ly-adv__sticky');
  const productReveal = article.querySelector('#adv-product-reveal');
  if (sticky && productReveal && 'IntersectionObserver' in window) {
    const revealSticky = new IntersectionObserver(([entry]) => {
      const visible = entry.isIntersecting || entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { rootMargin: '0px 0px -35% 0px', threshold: 0.01 });
    revealSticky.observe(productReveal);
  }

  publish('advertorial_view', { path: window.location.pathname });

  article.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-ly-adv-cta]');
    if (!cta) return;
    publish('advertorial_cta_click', {
      source: cta.dataset.ctaSource || 'unknown',
      position: cta.dataset.ctaPosition || 'inline',
      destination: new URL(cta.href, window.location.origin).pathname,
    });
  });

  article.querySelectorAll('.ly-adv__faq details').forEach((item) => {
    item.querySelector('summary')?.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    item.addEventListener('toggle', () => {
      item.querySelector('summary')?.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      if (item.open) publish('advertorial_faq_open', { question: item.querySelector('summary')?.textContent?.trim() || '' });
    });
  });

  const reached = new Set();
  let ticking = false;
  const checkDepth = () => {
    ticking = false;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const depth = max > 0 ? Math.round((window.scrollY / max) * 100) : 100;
    [25, 50, 75, 90].forEach((mark) => {
      if (depth >= mark && !reached.has(mark)) {
        reached.add(mark);
        publish('advertorial_scroll_depth', { percent: mark });
      }
    });
  };
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(checkDepth);
  }, { passive: true });
  checkDepth();
})();
